
<button class="menu-button" @click="$emit('click')">
  <template v-if="isCollapsed">
    <div class="menu-button__collapsed-button">
      <div class="button__icon">
        <img :src="CollapsedIconPath" />
      </div>
      <div class="button__text">メニュー</div>
    </div>
  </template>
  <template v-else>
    <div class="menu-button__expanded-button">
      <img :src="ExpandIconPath" />
      <div class="button__text">メニューを閉じる</div>
    </div>
  </template>
</button>
